import { render, staticRenderFns } from "./CompanyTabOnboarding.vue?vue&type=template&id=a5cd082a&scoped=true&"
import script from "./CompanyTabOnboarding.vue?vue&type=script&lang=js&"
export * from "./CompanyTabOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTabOnboarding.vue?vue&type=style&index=0&id=a5cd082a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cd082a",
  null
  
)

export default component.exports